<template>
  <article class="group" data-component="CardHighlight">
    <AtomLink :url="url" class="grid grid-cols-1 text-black border-b-2 border-solid border-app-lime rounded-lg overflow-hidden">
      <figure class="figure-background aspect-square relative block shrink-0 col-span-full row-end-6 row-start-1 overflow-hidden">
        <MoleculePicture class="v-hover-zoom-image w-full h-full object-cover transform transition duration-200" :image="image" :alt="imgAlt" />
      </figure>
      <section class="relative z-10 flex flex-col col-span-full row-end-6 row-start-auto items-start 2xl:pl-12 pl-8 pr-16 2xl:pr-20 2xl:py-12 py-8">
        <h2 v-if="title" class="order-2 text-white 2xl:text-2xl text-xl font-bold leading-tight uppercase">{{ title }}</h2>
        <p v-if="label" class="inline-flex order-1 mb-2 px-4 py-2 leading-none bg-app-lime rounded-tr-2xl uppercase">
          {{ label }}
        </p>
        <AtomIconArrowRight class="absolute bottom-0 right-0 mb-4 mr-4 w-5 h-5 text-white transform group-hover:translate-x-1 transition duration-200 md:mb-6 md:mr-6" />
      </section>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
interface Props {
  url?: string
  title?: string
  label?: string
  image?: object
  imgAlt?: string
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.figure-background::after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(53.31deg, #000000 -11.59%, rgba(0, 0, 0, 0) 68.36%);
}
</style>
